<div class="relative">
  <form [formGroup]="newUserFrom" (ngSubmit)="newUserFrom.valid ? createUser() : setFormDirty(newUserFrom)" >
    <div class="input__container">
      <label for="firstName">Förnamn</label>
      <input id="firstName" formControlName="firstName" type="text" [wooInputErrors]="{absolute: true}">
    </div>
    <div class="input__container padding-top--1x">
      <label for="lastName">Efternamn</label>
      <input id="lastName" formControlName="lastName" type="text" [wooInputErrors]="{absolute: true}">
    </div>
    <div class="input__container padding-top--1x">
      <label for="email">Email</label>
      <input id="email" formControlName="email" type="email" [wooInputErrors]="{absolute: true}">
    </div>
    @if (allowToChangeRole) {
      <div class="select__container mg-top">
        <label for="role">Välj roll</label>
        <select id="role" formControlName="role" [wooInputErrors]="{absolute: true}">
          <option value=""></option>
          @for (role of availableRoles; track $index) {
            <option [value]="role">{{ convertRoles(role) }}</option>
          }
        </select>
      </div>
    }


    @if (selectAdOrgData) {
      <div class="padding-top--2x">
        @if(!role.valid) {
          <br>
        }
        <small class="padding-bottom--2x">Rollen behöver knytas till en organisation.</small>
        <div class="select__container">
          <label for="organisation">Välj organisation</label>
          <select id="organisation" formControlName="organisation">
            <option value=''></option>
            @for (org of selectAdOrgData.organisations; track $index) {
              <option [ngValue]="org">{{ org.name }}</option>
            }
          </select>
        </div>
      </div>
    }

    @if (selectCustomerData) {
      <div class="margin-bottom--3x">
        <small>{{selectCustomerData.description}}</small>
        <div class="select__container">
          <label for="customer">Välj kund</label>
          <select id="customer" formControlName="customer">
            <option value=''></option>
            @for (customer of selectCustomerData.customers; track $index) {
              <option [ngValue]="customer">{{ customer.name }}</option>
            }
          </select>
        </div>
      </div>
    }

    @if (selectAgency && allowedToAssignAgencyRoles) {
      <div class="margin-bottom--3x">
        <small>
          Byråanvändare behöver knytas till en eller flera byråer. De kan även ges administratörsrättigheter för
          respektive byrå.
        </small>
        <agency-role-select formControlName="agencyRoles" [agencies]="agencies"></agency-role-select>
      </div>
    }

    <div class="padding-top--2x">
      <button type="submit" class="button primary-1" [disabled]="newUserFrom.invalid">{{submitLabel}}</button>
      <button type="button" (click)="onAbort.emit()" class="link primary-1">Avbryt</button>
    </div>
  </form>
  @if (!loadingCompleted) {
    <div class="position--absolute display--flex justify-content--center align-items--center cover">
      <dot-loader [visibility]="true" [large]="true"></dot-loader>
    </div>
  }
</div>
